import { trainingCourseListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const trainingCourseListRouteMetadata: IRouteMetadataObj<
  typeof trainingCourseListRoutesObj
> = {
  list: {
    title: "trainingCourseList.index.title",
    description: "trainingCourseList.index.description",
    lazy: () => import("@/pages/studentPages/trainingCourseList/table/page"),
    mode: "index",
    type: "main",
    icon: "BookLine",
    breadcrumbs: [],
    permission,
    noUser: true,
  },
  view: {
    title: "trainingCourseList.view.title",
    description: "trainingCourseList.view.description",
    lazy: () => import("@/pages/studentPages/trainingCourseList/view/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    isPageFullMode: true,
    permission,
    noUser: true,
  },
};

export const trainingCourseListRoutes = createRoute<
  typeof trainingCourseListRoutesObj
>(trainingCourseListRoutesObj, trainingCourseListRouteMetadata);
